import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { get } from "lodash";

import { Field, FieldError, FieldLabel } from "@/components/ui/field";

import ListInput from "./ListInput";
import { REQUIRED_MARK } from "./fieldClasses";

const FormChipList = ({ name, label, required, placeholder, disabled, id }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);
  const inputId = id ?? name;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Field data-invalid={error ? true : undefined}>
          {label && (
            <FieldLabel
              htmlFor={inputId}
              className={required ? REQUIRED_MARK : undefined}
            >
              {label}
            </FieldLabel>
          )}
          <ListInput
            id={inputId}
            value={Array.isArray(field.value) ? field.value : []}
            onChange={field.onChange}
            error={!!error}
            required={required}
            disabled={disabled}
            placeholder={placeholder}
          />
          <FieldError>{error?.message}</FieldError>
        </Field>
      )}
    />
  );
};

FormChipList.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

export default FormChipList;
